<div class="min-h-screen bg-offwhite3">
    <div class="flex h-screen items-center justify-center">
        <div class="flex w-full max-w-[860px] flex-col gap-1 rounded-lg bg-white p-8 shadow-card">
            <h1 class="text-center text-3xl font-bold uppercase text-brand1">404</h1>
            <h2 class="text-center text-3xl font-bold text-gray1">
                {{ 'messages.notFound.pageIsNotFound' | transloco }}
            </h2>
            <img src="assets/imgs/not-found.gif" class="h-auto" />
            <button
                type="button"
                (click)="onBackClick()"
                class="my-5 w-60 self-center rounded-full bg-brand1 py-3 px-4 text-white disabled:opacity-75"
            >
                {{ text$ | async }}
            </button>
        </div>
    </div>
</div>
